import React from 'react';
import { connect } from 'react-redux';

import without from '../../utils/without';

function UserStyle({ children, customization, ...props }) {
  const cleanedProps = without(props, 'selector');
  const child = React.Children.only(children);

  if (!customization || !Object.keys(cleanedProps).length) {
    return null;
  }

  const appliedStyles = Object.keys(cleanedProps)
    .filter(p => cleanedProps[p])
    .reduce((styles, prop) => {
      const key = prop === 'domStyle' ? 'style' : prop;
      const value = cleanedProps[prop];
      let propertyTransformer = f => f;
      let fields;

      if (Object.prototype.toString.call(value) === '[object Object]') {
        fields = [].concat(value.name);
        if (value.propertyTransformer) {
          propertyTransformer = value.propertyTransformer;
        }
      } else {
        fields = [].concat(value);
      }

      const constructedStyle = fields.reduce((fieldStyles, field) => {
        let name = field;
        if (field === Object(field)) {
          name = field.name;
        }
        return ({
          ...fieldStyles,
          [name]: customization,
        });
      }, {});

      return {
        ...styles,
        [key]: propertyTransformer({
          ...child.props[key],
          ...constructedStyle,
        }),
      };
    }, {});

  return React.cloneElement(child, appliedStyles);
}

export function isObject(o) {
  return o === Object(o);
}

export function byString(o, s) {
  const a = s
    .replace(/\[(\w+)]/g, '.$1') // convert indexes to properties
    .replace(/^\./, '') // strip a leading dot
    .split('.');
  let tmp = o;
  while (a.length) {
    const k = a.shift();
    if (isObject(tmp) && k in tmp) {
      tmp = tmp[k];
    } else {
      return '';
    }
  }
  return tmp;
}


export function valueByPath(obj, ...paths) {
  if (!isObject(obj)) {
    throw new Error('Invalid usage! Expected first argument to be an object');
  }

  if (!paths.length) {
    throw new Error('Invalid usage! Expected second argument to be an array or spread of strings');
  }

  const initialValue = new Date().valueOf();
  return paths.reduce((result, path) => {
    if (result !== initialValue && result !== undefined) {
      return result;
    }
    return byString(obj, path);
  }, initialValue);
}

export default connect(
  (state, { selector }) => ({
    customization: valueByPath(state, selector),
  }),
  {},
)(UserStyle);



// WEBPACK FOOTER //
// ./src/components/UserCustomization/UserStyle.js